<template>
  <v-content id="bodyContentContainer">
    <!-- style="position: relative;height: 100vh;" -->

    <v-card
        style=height:100%
        flat
        tile
    >
      <router-view />
    </v-card>
  </v-content>
</template>

<script>
export default {
  name: "dlconBody",
}
</script>

<style scoped>
#bodyContentContainer {
}

</style>
